<!--
  Gestione Prodotti — Dettagli (filtered by category).
  Redesigned 2026-06-11 (v2.7.0, Phase 1.5 Chunk B.2).

  Reached by clicking a leaf in the "Vista Categorie" of
  gestione-prodotti-list. The URL params drive the filter:
    /products/:family[/:subfamily[/:group[/:subgroup]]]

  Pattern matches Chunk B.1: sticky header (with breadcrumb), filter
  bar, Diakonix table, click row → detail modal (Chunk B.3). Drops
  kendo-grid + mat-spinner + ~30 inline styles.
-->

<div class="inventory-page">

  <!-- ─── Sticky header w/ breadcrumb ──────────────────────────── -->
  <header class="inventory-header">
    <div class="inventory-header__titles">
      <h1 class="inventory-header__title">
        🗂 Prodotti filtrati per categoria
      </h1>

      <nav class="breadcrumb" aria-label="Categoria attiva">
        <button
          type="button"
          class="breadcrumb__crumb breadcrumb__crumb--root"
          routerLink="/products"
          title="Torna al catalogo"
        >📦 Catalogo</button>

        @if (family) {
          <span class="breadcrumb__sep">›</span>
          <span class="breadcrumb__crumb">{{ family }}</span>
        }
        @if (subFamily) {
          <span class="breadcrumb__sep">›</span>
          <span class="breadcrumb__crumb">{{ subFamily }}</span>
        }
        @if (group) {
          <span class="breadcrumb__sep">›</span>
          <span class="breadcrumb__crumb">{{ group }}</span>
        }
        @if (subGroup) {
          <span class="breadcrumb__sep">›</span>
          <span class="breadcrumb__crumb breadcrumb__crumb--leaf">
            {{ subGroup }}
          </span>
        }
      </nav>

      <p class="inventory-header__subtitle">
        @if (gridData.length > 0) {
          {{ gridData.length }}
          {{ gridData.length === 1 ? 'prodotto' : 'prodotti' }}
          @if (filterTerm) { · filtro <strong>"{{ filterTerm }}"</strong> }
        } @else if (loading) {
          Caricamento prodotti…
        } @else {
          Nessun prodotto in questa categoria
        }
      </p>
    </div>

    <button
      type="button"
      class="btn btn--ghost"
      routerLink="/products"
      title="Torna al catalogo"
    >← Catalogo</button>
  </header>

  <!-- ─── Filter bar ───────────────────────────────────────────── -->
  <section class="inventory-filters" aria-label="Filtri ricerca">
    <div class="filter-field">
      <label class="filter-field__label" for="searchInCategory">
        Cerca prodotto nella categoria
      </label>
      <div class="filter-field__input-wrap">
        <input
          id="searchInCategory"
          type="search"
          class="filter-field__input"
          placeholder="Codice o descrizione…"
          [(ngModel)]="filterTerm"
          (keyup.enter)="searchProducts()"
        />
        @if (filterTerm) {
          <button
            type="button"
            class="filter-field__clear"
            (click)="clearSearch()"
            aria-label="Rimuovi filtro"
          >×</button>
        }
      </div>
    </div>

    <button
      type="button"
      class="btn btn--primary"
      (click)="searchProducts()"
      [disabled]="loading"
    >🔍 Cerca</button>
  </section>

  <!-- ─── Table card ───────────────────────────────────────────── -->
  <section class="inventory-table-card" aria-label="Elenco prodotti">

    @if (loading) {
      <div class="table-skeleton" aria-busy="true">
        @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
          <div class="table-skeleton__row">
            <div class="table-skeleton__line table-skeleton__line--lg"></div>
            <div class="table-skeleton__line table-skeleton__line--md"></div>
            <div class="table-skeleton__line table-skeleton__line--sm"></div>
          </div>
        }
      </div>
    } @else if (gridData.length === 0) {
      <div class="inventory-empty">
        <div class="inventory-empty__icon" aria-hidden="true">
          @if (filterTerm) { 🔎 } @else { 📭 }
        </div>
        <p class="inventory-empty__msg">
          @if (filterTerm) {
            Nessun prodotto corrisponde a <strong>"{{ filterTerm }}"</strong> in
            questa categoria.
          } @else {
            Nessun prodotto in questa categoria.
          }
        </p>
      </div>
    } @else {
      <div class="inventory-table-scroll">
        <table class="inventory-table" role="table">
          <thead>
            <tr>
              <th class="col-cat">Famiglia</th>
              <th class="col-cat">Sotto-Famiglia</th>
              <th class="col-cat">Gruppo</th>
              <th class="col-cat">Sotto-Gruppo</th>
              <th class="col-code">Codice</th>
              <th class="col-desc">Descrizione</th>
              <th class="col-num">Quantità</th>
              <th class="col-actions" aria-label="Azioni"></th>
            </tr>
          </thead>
          <tbody>
            @for (
              item of gridData;
              track item.pr_code + '-' + ($index)
            ) {
              <tr
                class="inventory-row"
                (click)="openDetail(item.pr_code, item.pr_description)"
                title="Apri dettagli prodotto"
              >
                <td class="col-cat">{{ item.family_desc || '—' }}</td>
                <td class="col-cat">{{ item.sub_family_desc || '—' }}</td>
                <td class="col-cat">{{ item.group_desc || '—' }}</td>
                <td class="col-cat">{{ item.sub_group_desc || '—' }}</td>
                <td class="col-code">
                  <span class="cell-code">{{ item.pr_code || '—' }}</span>
                </td>
                <td class="col-desc">
                  <span class="cell-desc">{{ item.pr_description || '—' }}</span>
                </td>
                <td class="col-num">
                  <span class="cell-num cell-num--strong">
                    {{ item.pr_stock ?? 0 }}
                  </span>
                </td>
                <td class="col-actions" (click)="$event.stopPropagation()">
                  <button
                    type="button"
                    class="icon-btn"
                    title="Apri dettagli"
                    (click)="openDetail(item.pr_code, item.pr_description)"
                  >ℹ️</button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>

</div>
